export default __webpack_public_path__ + "static/media/logo.5cb8405c.svg";